import packageJson from '../../package.json';

export class GlobalConstants {
	public static appVersion: string = packageJson.version;
	public static fullCalendarLicenseKey = '0195398351-fcs-1707402081';
}
